
export const delay = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export const isObject = (value) => {
  return value && typeof value === 'object' && value.constructor === Object;
}
